<template>
  <div class='EnbFilterCateg'>
    <label class="label">Qual produto deseja?</label>
    <div class="cont-categ">
      <label
      class="categ"
      v-for="(c, key) in categorias"
      :key="key"
      >
        <input
        type="checkbox"
        :value="c.name"
        :checked="modelValue.includes(c.name)"
        @change="toggle(c.name)"
        />
        <span class="check"></span>
        {{ c.name }}
      </label>
    </div>
    <div class="clear" v-if="modelValue.length" @click="clear">
      &#10005; Limpar filtros
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'EnbFilterCateg',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'clear'],
  computed: {
    ...mapGetters(['Categorias']),
    categorias () {
      return this.Categorias.filter(c => c.name !== '')
    }
  },
  methods: {
    ...mapActions(['GetCategory']),
    toggle (name) {
      let selected = this.modelValue.includes(name)
        ? this.modelValue.filter(c => c !== name)
        : [...this.modelValue, name]
      this.$emit('update:modelValue', selected)
    },
    clear () {
      this.$emit('update:modelValue', [])
      this.$emit('clear')
    }
  },
  created () {
    this.GetCategory()
  }
}
</script>

<style scoped>
.EnbFilterCateg {
  width: 100%;
  padding-bottom: 30px;
}

.label {
  display: block;
  font-size: 1rem;
  text-transform: uppercase;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: thin solid #E2E8F0;
}

.cont-categ {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.categ {
  display: flex;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
}

.categ input {
  display: none;
}

.check {
  width: 18px;
  min-width: 18px;
  height: 18px;
  margin-right: 8px;
  border: thin solid #999999;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.categ input:checked + .check {
  background-color: #333333;
  border-color: #333333;
}

.categ input:checked + .check::after {
  content: '';
  width: 4px;
  height: 8px;
  border: solid #FFFFFF;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) translate(-1px, -1px);
}

.clear {
  margin-top: 20px;
  font-size: 12px;
  text-transform: uppercase;
  cursor: pointer;
}

.clear:hover {
  text-decoration: underline;
}
</style>
